import { CheckboxTheme } from '@/components/Checkbox/theme';
import { InputCaption as StandaloneInputCaption } from '@/components/InputCaption';
import { GenericSlot, GenericSlotFactory } from 'base/components/GenericSlot';

const $ = GenericSlotFactory({ theme: CheckboxTheme });

const Base = $({ as: 'div', slot: 'base' });
const Label = $({ as: 'label', slot: 'label' });
const Input = $({ as: 'input', slot: 'input' });
const Caption = GenericSlot({ as: StandaloneInputCaption, theme: CheckboxTheme.Caption });

export const Checkbox = Object.assign(Base, { Caption, Input, Label });
